import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { StartTrialSources } from "modules/tracking/segment/types";
import { useContext } from "react";
import { useHistory } from "react-router";

interface Props {
  startTrialSource: StartTrialSources;
}

export const useStartTrial = ({ startTrialSource }: Props) => {
  const { track } = useContext(TRACKING_CONTEXT);
  const { push } = useHistory();

  const handleStartTrial = async () => {
    track(Events.START_TRIAL_CLICKED, { startTrialSource });
    push("/create-company");
  };

  return { handleStartTrial };
};
